export default "__VITE_ASSET__Sonvu60y__"